/**
 * Mock data for Activity Details screen
 */

import { ActivityDetailsData, RecommendedActivity } from './types';

// Using placeholder image from assets
import activityImage from '../../../assets/images/default-activity.jpeg';
import kidAvatar from '../../../assets/mockups/activity/kid-avatar.png';

export const mockRecommendations: RecommendedActivity[] = [
  {
    id: 'rec-1',
    title: 'Storytime Treasure Hunt',
    description: 'Hide story-related objects around the room and have your child find and describe or act them out.',
    imageUrl: activityImage,
    likesCount: 134,
    duration: '10 min',
    playType: 'Solo Play',
    prepNeeded: 'No prep needed',
    benefitText: "This activity enhances a child's color recognition, and attention to detail while promoting cognitive and problem-solving skills.",
    benefitKeywords: ['color recognition', 'attention to detail'],
  },
  {
    id: 'rec-2',
    title: 'Color Match Hunt',
    description: 'Searches the room to find objects that match a set of colored papers or toys.',
    imageUrl: activityImage,
    likesCount: 134,
    duration: '10 min',
    playType: 'Play together',
    prepNeeded: 'No prep needed',
    benefitText: "This activity enhances a child's visual discrimination, color recognition, and attention to detail while promoting cognitive and problem-solving skills.",
    benefitKeywords: ['visual discrimination', 'color recognition', 'attention to detail'],
  },
];

export const mockActivityDetails: ActivityDetailsData = {
  id: 'activity-1',
  title: 'Sentence Builders',
  description: "Expand your child's short phrases into longer sentences through play.",
  imageUrl: activityImage,
  likesCount: 134,
  metadata: {
    duration: '10 min',
    playType: 'Play together',
    prepNeeded: 'No prep needed',
  },
  tags: [
    { id: 'tag-1', label: 'Speech & Language' },
    { id: 'tag-2', label: 'Fine motor control' },
    { id: 'tag-3', label: 'Focus' },
    { id: 'tag-4', label: 'Early Learning' },
  ],
  recommendedFor: {
    name: 'Sam',
    avatarUrl: kidAvatar,
  },
  steps: [
    {
      id: 1,
      text: "When child says 'want juice', model 'I want apple juice'",
      emphasis: 'model',
    },
    {
      id: 2,
      text: "Don't force them to repeat - just model it",
      emphasis: "Don't force them",
    },
    {
      id: 3,
      text: "During play, narrate: 'The red car goes fast'",
      emphasis: 'narrate',
    },
    {
      id: 4,
      text: "Ask open questions: 'What's happening in the story?'",
      emphasis: 'open questions',
    },
    {
      id: 5,
      text: 'Add one word to what they say',
      emphasis: 'Add one word',
    },
  ],
  tips: [
    {
      id: 1,
      text: "Don't correct - just model the right way",
      boldText: "Don't correct",
    },
    {
      id: 2,
      text: 'Use their interests (cars, dolls, etc.)',
      boldText: 'Use their interests',
    },
    {
      id: 3,
      text: 'Keep it fun and natural',
      boldText: 'Keep it fun',
    },
  ],
  whyItWorks: {
    text: 'This activity improves speech and language skills by increasing sentence length and complexity',
    boldKeywords: ['speech and language skills'],
  },
  recommendations: mockRecommendations,
};
